import script from "./Repair01Roof.vue?vue&type=script&setup=true&lang=js"
export * from "./Repair01Roof.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__